import React from "react";

/**
 * Top-level ErrorBoundary. Când o eroare React scapă necontrolată (de exemplu
 * la interacțiuni cu componente Radix pe mobil), în loc de ecran alb afișăm
 * un mesaj prietenos + buton "Reîncarcă". Astfel utilizatorul nu pierde
 * complet contextul și avem un fallback vizibil în producție.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || "Eroare neașteptată" };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  handleReload = () => {
    try {
      window.location.reload();
    } catch (_) {
      /* noop */
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          data-testid="error-boundary-fallback"
          className="min-h-screen flex items-center justify-center bg-slate-50 p-6"
        >
          <div className="max-w-md w-full rounded-lg border bg-white shadow-sm p-6 text-center">
            <h1 className="text-lg font-semibold text-slate-900 mb-2">A apărut o problemă</h1>
            <p className="text-sm text-slate-600 mb-4">
              Pagina nu a putut fi afișată. Te rugăm să reîncarci și să încerci din nou.
            </p>
            {this.state.message && (
              <p className="text-xs text-slate-400 mb-4 font-mono break-words">{this.state.message}</p>
            )}
            <button
              type="button"
              onClick={this.handleReload}
              className="inline-flex items-center justify-center rounded-md bg-primary text-primary-foreground px-4 py-2 text-sm font-medium hover:bg-primary/90"
              data-testid="error-boundary-reload"
            >
              Reîncarcă pagina
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
